import React from "react";
import { Link } from "react-router-dom";

export default function Default() {
  return (
    <div className="container text-center text-uppercase py-5">
      <h1>404 error</h1>
      <p>
        Page not found. Back to <Link to="/">home</Link>
      </p>
    </div>
  );
}
